import React, {useContext} from 'react';
import TranslationContext from '../../../../../context/TranslationContext';

const BarCDTicker = ({progress}) => {

    const {getTranslation} = useContext(TranslationContext)

    return (
        <div className="bar-countdown">
            <div className="progress-bar"
                style={{width: `${100 - progress}%`}}
            />
            <div className="bar-countdown-text">
                    <span data-id_phrase="remain">{getTranslation("remain")}</span>&nbsp;
                    <span>{progress}</span>
                    <span data-id_phrase="sec">{getTranslation("sec")}</span>
            </div>
        </div>
    )
}


export default BarCDTicker